import type { TextareaHTMLAttributes } from 'react'

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
}

export const TextArea = ({ label, className = '', ...props }: TextAreaProps) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium mb-1">{label}</label>
      )}
      <textarea
        {...props}
        className={`w-full h-[91px] py-2 px-3 border border-[#D9D9D9] bg-muted text-foreground rounded-[10px] focus:outline-none  resize-none ${className}`}
      />
    </div>
  )
}